import { useState, useEffect } from "react";

const COLUMN_WIDTH_STORAGE_KEY = "panda_column_widths";

export const useColumnResizing = () => {
  const [columnWidths, setColumnWidths] = useState({});
  const [resizingColumn, setResizingColumn] = useState(null);

  // Load saved column widths from localStorage
  useEffect(() => {
    try {
      const savedWidths = localStorage.getItem(COLUMN_WIDTH_STORAGE_KEY);
      if (savedWidths) {
        setColumnWidths(JSON.parse(savedWidths));
      }
    } catch (err) {
      console.error("Error loading saved column widths:", err);
    }
  }, []);

  // Save column widths to localStorage when they change
  useEffect(() => {
    if (Object.keys(columnWidths).length > 0) {
      try {
        localStorage.setItem(COLUMN_WIDTH_STORAGE_KEY, JSON.stringify(columnWidths));
      } catch (err) {
        console.error("Error saving column widths:", err);
      }
    }
  }, [columnWidths]);

  // Handle column resize
  const handleResizeMouseDown = (e, columnId) => {
    e.preventDefault();
    setResizingColumn(columnId);

    const startX = e.pageX;
    const currentWidth = columnWidths[columnId] || 150;

    const handleMouseMove = (moveEvent) => {
      const newWidth = Math.max(80, currentWidth + (moveEvent.pageX - startX));
      setColumnWidths((prev) => ({
        ...prev,
        [columnId]: newWidth,
      }));
    };

    const handleMouseUp = () => {
      setResizingColumn(null);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return {
    columnWidths,
    resizingColumn,
    handleResizeMouseDown,
  };
};
